import type { UseMutationOptions, UseMutationResult } from "react-query";
import { useMutation } from "react-query";
import { useToast } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import downloadFile from "ui/common/utils/downloadFile";
import type { ExportGiftCardsStrategy } from "ui/giftcards/containers/ExportGiftCardsModal/ExportGiftCardsModal.types";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UseExportPurchasedGiftCardsParams extends Record<string, unknown> {
    partner?: string;
    strategy: ExportGiftCardsStrategy;
    startDate?: string;
    endDate?: string;
    onlyPending?: boolean;
}

export interface ExportResponse {
    data: Blob;
    extension: string;
    fileName?: string;
}

export default function useExportPurchasedGiftCards(
    options?: UseMutationOptions<ExportResponse, unknown, UseExportPurchasedGiftCardsParams>,
): UseMutationResult<ExportResponse, unknown, UseExportPurchasedGiftCardsParams> {
    const translate = useTranslate();
    const { showToast } = useToast();

    return useMutation(
        async ({ partner, strategy, startDate, endDate, onlyPending }: UseExportPurchasedGiftCardsParams) => { // skipcq: JS-0116
            return giftcardsApi.exportPurchasedGiftCards({
                partner,
                strategy,
                startDate,
                endDate,
                status: onlyPending ? "PENDING" : undefined,
            });
        },
        {
            onSuccess: (response) => {
                if (response.data instanceof Blob) {
                    downloadFile(response.data, response.fileName || "gift_cards_report", response.extension);
                }
                showToast(translate("transactionsExportSuccess"), { type: "success" });
            },
            ...options,
        },
    );
}
